import React from 'react';
import { styled, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useLaptop } from 'hooks';
import { GetStaticProps } from 'next';
import { getTranslations } from '../utils/i18n-cache';

const CookiesPage = () => {
  const { isOverLaptop } = useLaptop();
  return (
    <Box>
      <Content>
        <Typography
          variant={isOverLaptop ? 'big500' : 'big700'}
          component={'p'}
          mb={isOverLaptop ? 3 : 1.5}
        >
          Cookies
        </Typography>
        <Typography
          component={'p'}
          variant={isOverLaptop ? 'average400' : 'average200'}
          mb={2}
        >
          At Shifa.one, we use cookies and similar technologies to enhance your
          browsing experience, improve website performance, and analyze traffic.
          This Cookie Policy explains what cookies are, how we use them, and
          your choices regarding their usage.
        </Typography>
        <Typography
          variant={isOverLaptop ? 'big500' : 'big700'}
          component={'p'}
          mb={isOverLaptop ? 3 : 1.5}
        >
          What Are Cookies?
        </Typography>
        <Typography
          component={'p'}
          variant={isOverLaptop ? 'average400' : 'average200'}
          mb={2}
        >
          Cookies are small text files stored on your device when you visit a
          website. They help the site remember your preferences and activity,
          providing a more personalized experience.
        </Typography>
        <Typography
          variant={isOverLaptop ? 'big500' : 'big700'}
          component={'p'}
          mb={isOverLaptop ? 3 : 1.5}
        >
          Types of Cookies We Use
        </Typography>
        <Typography
          component={'p'}
          variant={isOverLaptop ? 'average400' : 'average200'}
          mb={2}
        >
          1. Essential Cookies: These are necessary for the website to function
          properly. Without them, you may not be able to access certain
          features. <br />
          2. Performance Cookies: These collect anonymous data on how visitors
          use our site, allowing us to improve its performance. <br />
          3. Functionality Cookies: These allow us to remember choices you make
          (e.g., your username, language, or region). <br />
          4. Targeting/Advertising Cookies: These track your browsing habits and
          help us serve more relevant advertisements to you.
        </Typography>
        <Typography
          variant={isOverLaptop ? 'big500' : 'big700'}
          component={'p'}
          mb={isOverLaptop ? 3 : 1.5}
        >
          How We Use Cookies
        </Typography>
        <Typography
          component={'p'}
          variant={isOverLaptop ? 'average400' : 'average200'}
          mb={2}
        >
          - To remember your login details and preferences.
          <br />- To improve site performance and user experience.
          <br />- To analyze site traffic and usage patterns.
          <br />- To deliver personalized ads that are relevant to you.
        </Typography>
        <Typography
          variant={isOverLaptop ? 'big500' : 'big700'}
          component={'p'}
          mb={isOverLaptop ? 3 : 1.5}
        >
          Your Consent
        </Typography>
        <Typography
          component={'p'}
          variant={isOverLaptop ? 'average400' : 'average200'}
          mb={2}
        >
          When you visit Shifa.one, you will be presented with a cookie banner
          asking you to consent to the use of cookies. By clicking
          &apos;Accept,&apos; you agree to our use of cookies as outlined in
          this policy. You can withdraw consent at any time by adjusting your
          browser settings or using our cookie management tool.
        </Typography>
      </Content>
    </Box>
  );
};

export default CookiesPage;

export const Content = styled(Box)(({ theme }) => ({
  padding: '60px 0 80px 0',
  [theme.breakpoints.down('laptop')]: {
    padding: '24px 0 40px 0',
  },
}));

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await getTranslations(locale ?? 'en')),
  },
});
